import { createContext, useContext } from 'react';

export interface InfoRevealState {
  openKey: string | null;
  toggle: (key: string) => void;
  clear: () => void;
}

export const InfoRevealContext = createContext<InfoRevealState>({
  openKey: null,
  toggle: () => {},
  clear: () => {},
});

export const useInfoReveal = () => useContext(InfoRevealContext);
